(function($) {

    $('.m-flexible-testimonials__slides').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: false,
        speed: 1000,
        fade: true
    });

})(jQuery);